/* eslint-disable no-unused-vars */
export enum FileType {
  ORIGINAL = 'original',
  TRANSLATED = 'translated',
  CERTIFICATE = 'certificate',
  INVOICE = 'invoice',
  COMMENT = 'comment',
}
